import { sum, weightedAverage } from './utility'

export const filters = [
    {
        key: 'schoolCloses',
        label: 'Your district closes a school',
        value: -0.01,
        active: false,
    },
    {
        key: 'neighboringSchoolCloses',
        label: 'A neighboring district closes a school',
        value: 0.004,
        active: false,
    },
    {
        key: 'privateSchoolOpens',
        label: 'A new private school opens nearby',
        value: -0.002,
        active: false,
    },
    {
        key: 'newEducationalProgram',
        label: 'Your district offers a new educational/magnet program',
        value: 0.008,
        active: false,
    },
    {
        key: 'newJobs',
        label: 'A large commercial/industrial development brings jobs to your district',
        value: 0.003,
        active: false,
    },
    {
        key: 'unemploymentIncrease',
        label: 'Local unemployment greatly increases',
        value: -0.007,
        active: false,
    },
]

export const values = (arr) => arr.map((i) => i.value)
export const active = (arr) => arr.filter((i) => i.active)
export const positive = (arr) => arr.filter((i) => i.value > 0)
export const negative = (arr) => arr.filter((i) => i.value < 0)

export const homesBuilt = {
    label: 'How many homes will be built in your district?',
    value: 0,
    min: 0,
    max: 500,
    step: 10,
}

export function averages(years, appliedFilters) {
    const rates = []

    // Skip first year
    for (let i = 1, il = years.length; i < il; i += 1) {
        const year = years[i]

        // Skip initial grade
        for (let x = 1, xl = year.enrollments.length; x < xl; x += 1) {
            const prev = years[i - 1].enrollments[x - 1] || 0
            const rate = prev ? (year.enrollments[x] - prev) / prev : 0;
            (rates[x - 1] = rates[x - 1] || []).push(rate + sum(values(appliedFilters)))
        }
    }

    // Average the rates for each grade
    const weightTotal = sum([...years.keys()])
    return rates.map((i) => weightedAverage(i, weightTotal))
}
